import React from 'react';
import '../../styles/APSIS.css';

export default function APSISStartups() {
  return (
    <div className="apsis-page">
      <div className="apsis-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">STARTUPS & TECH</span>
            <h1>STARTUPS & TECH</h1>
            <p>Discover innovative startups and emerging technologies in security</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        <section className="apsis-startups-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>FEATURED STARTUPS</h2>
           </div>

           <div className="startups-grid">
              <div className="startup-card">
                 <div className="startup-logo">
                    <div className="logo-placeholder">STARTUP</div>
                 </div>
                 <h3>SecureTech Solutions</h3>
                 <p>Revolutionary cybersecurity platform for SMEs</p>
                 <div className="startup-stage">Series A</div>
                 <div className="startup-sector">Cybersecurity</div>
              </div>

              <div className="startup-card">
                 <div className="startup-logo">
                    <div className="logo-placeholder">STARTUP</div>
                 </div>
                 <h3>IoT Guardian</h3>
                 <p>Smart device protection and monitoring solutions</p>
                 <div className="startup-stage">Seed</div>
                 <div className="startup-sector">IoT Security</div>
              </div>

              <div className="startup-card">
                 <div className="startup-logo">
                    <div className="logo-placeholder">STARTUP</div>
                 </div>
                 <h3>BioSecure</h3>
                 <p>Biometric authentication systems for enterprise</p>
                 <div className="startup-stage">Series B</div>
                 <div className="startup-sector">Biometrics</div>
              </div>
           </div>
        </section>
      </div>
    </div>
  );
}